const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  {
    path: '/urm',
    name: 'URM',
    component: _import('manage/index'),
    children: [
      {
        // 到面管理
        path: 'urm-index',
        name: 'UrmIndex',
        component: _import('urm/index')
      },
      {
        // 全部职位列表
        path: 'urm-infoList',
        name: 'UrmInfolist',
        component: _import('urm/info-list')
      },
      {
        // 职位详情
        path: 'detail',
        name: 'UrmInfoDetail',
        component: _import('urm/info-detail')
      },
      {
        // 全部简历列表
        path: 'urm-resumeList',
        name: 'UrmResumelist',
        component: _import('urm/resume-list')
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/urm.router.js